import { useRef, useState } from 'react';
import { saveAs } from 'file-saver';

const useDownloader = (request: any, options: any) => {
  const [downloading, setDownloading] = useState(false);
  const [downloadPercentage, setDownloadPercentage] = useState(0);
  const interval = useRef<any>();
  const startDownloadProgress = () => {
    setDownloading(true);

    // using random download progress logic
    interval.current = setInterval(() => {
      setDownloadPercentage(currentDownloadPercent => {
        return currentDownloadPercent < 80 ? currentDownloadPercent + 1 : currentDownloadPercent;
      });
    }, 1000);
  };

  const cleanUp = () => {
    setDownloading(false);
    clearInterval(interval.current);
    setDownloadPercentage(0);
  };

  const start = (afterEffects?: Function) => {
    startDownloadProgress();

    request().then((res) => {
      setDownloadPercentage(100);

      setTimeout(() => {
        if (interval.current) {
          clearInterval(interval.current);
          const blob = new Blob([res], { type: options.type });
          saveAs(blob, options.filename);
        }

        if (afterEffects) {
          afterEffects();
        }
        cleanUp();
      }, 2000);

    }, () => {
      if (afterEffects) {
        afterEffects();
      }
      cleanUp();
    });
  };

  const cancel = (afterEffects?: Function) => {
    if (afterEffects) {
      afterEffects();
    }
    cleanUp();
  };

  return { downloadPercentage, downloading, start, cancel };
};

export default useDownloader;
